import * as Func from '../../../../../../../helpers/functions';
import * as HMS from "../../../../../common/component/Index";

import AntSelect, { AntOption } from "containers/backend/common/component/AntSelect";
import { DATE_TIME_FORMAT, DETAIL_ACTIONS, TOUR } from "constants/Define";
import { Input, Modal, Switch } from "antd";
import React, { useEffect } from "react";
import { isEmpty, omit } from "lodash";

import Wrapper from "containers/backend/common/component/Wrapper";
import action from '../../../../../../../actions/index';
import classNames from "classnames";
import moment from "moment";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const PriceConfigDetail = (props) => {
    const { visible, setVisiblePrice, priceConfig, setPriceConfig, roomTypeList, actionType, hotelId, ratePlanId } = props;
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        if (actionType === DETAIL_ACTIONS.UPDATE){
            const filteredRoomTypes = roomTypeList.filter(roomType => priceConfig.roomTypeIds.includes(roomType.id));
            const roomTypeNames = filteredRoomTypes.map(roomType => `${roomType.name}:${roomType.id}`);
            setPriceConfig({
                ...priceConfig,
                roomTypeIds: roomTypeNames,
            })
        }
    }, [visible])

    const disabledPublishDate = (current) => {
        return current && current <= moment().add(-1, 'day');
    }

    const onChangePoint = (e) => {
        setPriceConfig({
            ...priceConfig,
            point: e.target.value
        });
    };

    const onSelectPriceConfigDate = data => {
        setPriceConfig({
            ...priceConfig,
            startDate: data.fullValue[0].format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT),
            endDate: data.fullValue[1].format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT),
        });
    };

    const onChangeRoomType = (data) => {
        setPriceConfig({
            ...priceConfig,
            roomTypeIds: data
        });
    }

    const onChangeIsActive = (value) => {
        setPriceConfig({
            ...priceConfig,
            isActive: value
        });
    }

    const handleSubmit = () => {
        setVisiblePrice(false)
        if (actionType === DETAIL_ACTIONS.CREATE) {
            const payload = {
                ...priceConfig,
                hotelId: hotelId,
                ratePlanId: ratePlanId,
                roomTypeIds: priceConfig.roomTypeIds.map(item => item.split(':')[1]).join(','),
            }
            dispatch(action.createPriceConfigBeachVilla(payload));
        } else {
            const payload = {
                ...priceConfig,
                hotelId: hotelId,
                ratePlanId: ratePlanId,
                roomTypeIds: priceConfig.roomTypeIds.map(item => item.split(':')[1]).join(','),
            }
            dispatch(action.updatePriceConfigBeachVilla(omit(payload, ['roomTypeInfos'])));
        }   
    }

    return (
        <Modal
            title={t('item.rate.priceConfig.title')}
            visible={visible}
            onOk={handleSubmit}
            onCancel={() => setVisiblePrice(false)}
            width={1000}
            okButtonProps={{
                disabled: isEmpty(priceConfig?.roomTypeIds)
            }}
        >
            <Wrapper className="row">
                <Wrapper className="col-md-6">
                    <HMS.FormWrapperInputComponent
                        labelTitle={t(`item.rate.priceConfig.valueTitle`)}
                    >
                        <Input
                            type={`number`}
                            min={0}
                            className={`form-control`}
                            name={`point`}
                            onChange={onChangePoint}
                            value={Func.formatNumber(priceConfig.point)}
                        />
                    </HMS.FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <HMS.FormWrapperInputComponent
                        labelTitle={t(`item.rate.priceConfig.availableTime`)}
                    >
                        <HMS.DatePickerComponent
                            className={classNames("form-control applyDates w100-percent")}
                            hmsComponent={`RangePicker`}
                            style={{ padding: 0, borderWidth: 0 }}
                            format={DATE_TIME_FORMAT.SHORT_DATE}
                            name={`RangePicker`}
                            value={(priceConfig?.startDate || priceConfig?.endDate)
                                ? [moment(priceConfig.startDate), moment(priceConfig.endDate)]
                                : []
                            }
                            disabledDate={disabledPublishDate}
                            onChange={onSelectPriceConfigDate}
                            placeholder={[
                                t("placeHolderForm.startDate"),
                                t("placeHolderForm.endDate"),
                            ]}
                        />
                    </HMS.FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-6">
                    <HMS.FormWrapperInputComponent
                        labelTitle={t(`item.rate.priceConfig.roomtyppe`)}
                    >
                        <AntSelect className="select-types"
                            showArrow
                            mode="multiple"
                            placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.rate.priceConfig.roomtyppe")).toLowerCase())}
                            value={priceConfig.roomTypeIds}
                            onChange={onChangeRoomType}
                            style={{ width: '100%' }}
                        >
                            {roomTypeList.map((roomType) => (
                                <AntOption key={roomType.id} value={`${roomType.name}:${roomType.id}`}>
                                    {roomType.name}
                                </AntOption>
                            ))}
                        </AntSelect>
                    </HMS.FormWrapperInputComponent>
                </Wrapper>
                {
                    actionType === DETAIL_ACTIONS.UPDATE &&
                    <Wrapper className="col-md-6">
                        <HMS.FormWrapperInputComponent
                            labelTitle={t(`item.rate.priceConfig.isActive`)}
                        >
                            <br />
                            <Switch
                                checked={priceConfig.isActive}
                                onChange={onChangeIsActive}
                                name={`isActive`}
                            />
                        </HMS.FormWrapperInputComponent>
                    </Wrapper>
                }
            </Wrapper>
        </Modal>
    );
};

export default PriceConfigDetail;
